module.exports = __webpack_public_path__ + "public/images/wavy-background-pattern.a3597936e055ed07dcea1f8e6e3e6e02.svg";